const ProjectileTmpl = {
    "life": 150,
    "speed": 5,
    "drawType": 2,
    "frame": 1,
    "drawSize": 0.9,
    "hitSound": true,
    "targetGround":true,
    "targetGroundSpread": 30,
    "largeHitEffect": true,
    "deflectionPower": 2,
    "areaDamage": 350,
    "areaRadius": 50,
    "lightColor": "#ffe92b",
    "lightSize": 0.6
}
export {ProjectileTmpl}
